export interface WorkspaceState {
  code: string;
  chatHistory: Array<{ role: 'user' | 'assistant'; content: string }>;
  savedDiagrams: Array<string>;
  lastSaved: number;
}

const DEFAULT_WORKSPACE: WorkspaceState = {
  code: '// Enter your Arduino/ESP32 code here\nvoid setup() {\n  Serial.begin(115200);\n}\n\nvoid loop() {\n  \n}',
  chatHistory: [],
  savedDiagrams: [],
  lastSaved: Date.now(),
};

export class ProjectManager {
  private static STORAGE_KEY = 'diymech_workspace_state';

  static saveWorkspace(state: Partial<WorkspaceState>) {
    try {
      const currentState = this.loadWorkspace();
      const newState = { ...currentState, ...state, lastSaved: Date.now() };
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newState));
    } catch (e) {
      console.error('Failed to save workspace state:', e);
    }
  }

  static loadWorkspace(): WorkspaceState {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      if (data) {
        return { ...DEFAULT_WORKSPACE, ...JSON.parse(data) };
      }
    } catch (e) {
      console.error('Failed to load workspace state:', e);
    }
    return { ...DEFAULT_WORKSPACE };
  }

  static clearWorkspace() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
